export default "__VITE_ASSET__Cr8sug5W__"